function PanSideViewRTSC(vars) {
  const getAngle = (p5, v1, v2) => +(Math.abs(degrees(Math.atan(
      (v1.y - v2.y) / (v1.x - v2.x),
  ))).toFixed(1));
  const { p5, backgroundPattern, state: {
    scale,
  } } = this;

  const {
    panDepth, panHeight, curbWidth, curbHeight, splashWallWidth,
    drainWidth, drainY, trenchFloorThickness, drainPlateWidth,
    depthDeclineTotal, grateThickness, drainPosition,
  } = vars;

  const { drainOpening } = panBaseSpec;

  const {
    cornerLineLength, panLineMargin,
  } = specConfig;

  const { toleranceRange } = specText;

  const margin = 100;
  const padding = 10;
  const panSide = createGraphics(panHeight + margin, panDepth + margin);

  panSide.fill(255);
  panSide.drawingContext.fillStyle = backgroundPattern;

  panSide.translate(padding, padding);

  // Curb Wall ends
  const curbMeetsFloor = createVector(
    panHeight - trenchFloorThickness - depthDeclineTotal,
    panDepth - curbWidth,
  );

  const frontOfDrainMeetsFloor = createVector(
    panHeight - trenchFloorThickness + grateThickness,
    drainY + (drainPlateWidth / 2),
  );

  const frontFloorAngle = getAngle(
    p5,
    curbMeetsFloor, frontOfDrainMeetsFloor,
  );

  // Create vector for floor slope angle
  const backOfDrainMeetsFloor = createVector(
    panHeight - trenchFloorThickness + grateThickness,
    drainY - (drainPlateWidth / 2),
  );

  const floorMeetsBackSplashWall = createVector(
    panHeight - trenchFloorThickness - depthDeclineTotal,
    splashWallWidth,
  );

  const backFloorAngle = getAngle(
    p5,
    floorMeetsBackSplashWall, backOfDrainMeetsFloor,
  );

  const grateWidthInches = this._getTrenchSize(this.state.panDepthInches - this.state.curbWidthInches - this.state.splashWallWidthInches);
  const floorOutsideTrench = panDepth - curbWidth - splashWallWidth - Math.round(grateWidthInches * scale);

  // Adjusting back splash wall height based on drain location
  let backWallAdjust = 0;

  const angleDelta = Math.abs(backFloorAngle - frontFloorAngle);
  let adjustmentPercentage = +((angleDelta / 10).toFixed(2));
  if (adjustmentPercentage > 1) adjustmentPercentage = 1;

  if (angleDelta > 2) {
    backWallAdjust = Math.ceil(depthDeclineTotal * adjustmentPercentage);
  }

  panSide.beginShape();
  panSide.vertex(0, 0);
  panSide.vertex(panHeight, 0);
  panSide.vertex(panHeight, panDepth);

  panSide.vertex(panHeight - curbHeight, panDepth);
  panSide.vertex(panHeight - curbHeight, panDepth - curbWidth);

  // Curb Floor Intersect
  if (drainPosition === 'Back') {
    panSide.vertex(curbMeetsFloor.x, curbMeetsFloor.y);
    panSide.vertex(frontOfDrainMeetsFloor.x - grateThickness, frontOfDrainMeetsFloor.y);
    panSide.vertex(frontOfDrainMeetsFloor.x, frontOfDrainMeetsFloor.y);
    panSide.vertex(backOfDrainMeetsFloor.x, backOfDrainMeetsFloor.y);
    panSide.vertex(backOfDrainMeetsFloor.x - grateThickness, backOfDrainMeetsFloor.y);
    panSide.vertex(
      floorMeetsBackSplashWall.x + backWallAdjust,
      splashWallWidth,
    );
  } else {
    panSide.vertex(curbMeetsFloor.x + depthDeclineTotal, curbMeetsFloor.y);
    panSide.vertex(curbMeetsFloor.x + depthDeclineTotal, curbMeetsFloor.y - (floorOutsideTrench / 2));
    panSide.vertex(curbMeetsFloor.x + depthDeclineTotal + grateThickness, curbMeetsFloor.y - (floorOutsideTrench / 2));
    panSide.vertex(frontOfDrainMeetsFloor.x, frontOfDrainMeetsFloor.y);
    panSide.vertex(backOfDrainMeetsFloor.x, backOfDrainMeetsFloor.y);
    panSide.vertex(backOfDrainMeetsFloor.x, floorOutsideTrench / 2);
    panSide.vertex(backOfDrainMeetsFloor.x - grateThickness, floorOutsideTrench / 2);
    panSide.vertex(floorMeetsBackSplashWall.x + depthDeclineTotal, splashWallWidth);
  }

  // Back Splash wall
  // panSide.vertex(
  //   floorMeetsBackSplashWall.x + backWallAdjust,
  //   splashWallWidth,
  // );

  panSide.vertex(0, splashWallWidth);
  panSide.vertex(0, 0);
  panSide.endShape();

  const hLine = cornerLineLength / 4;
  const vLine = cornerLineLength / 4;

  image(panSide, -(padding), -(padding));

  // Top splash wall measurement lines
  line(
    -(hLine + panLineMargin), 0,
    -(panLineMargin), 0,
  );

  // Inner Line
  line(
    -(hLine + panLineMargin), splashWallWidth,
    -(panLineMargin), splashWallWidth,
  );

  // Inner Curb
  line(
    -(hLine + panLineMargin), panDepth - curbWidth,
    -(panLineMargin), panDepth - curbWidth,
  );

  // Outer curb horizontal line
  line(
    -(hLine + panLineMargin), panDepth,
    -(panLineMargin), panDepth,
  );

  // Vertical line back splash wall
  line(
    0, -(vLine + panLineMargin),
    0, -(panLineMargin),
  );

  // Vertical Pan Bottom
  line(
    panHeight, -(vLine + panLineMargin),
    panHeight, -(panLineMargin),
  );

  // Vertical curb bottom
  line(
    panHeight, panDepth + panLineMargin,
    panHeight, panDepth + panLineMargin + vLine,
  );

  // Vertical curb top
  line(
    panHeight - curbHeight, panDepth + panLineMargin,
    panHeight - curbHeight, panDepth + panLineMargin + vLine,
  );

  // Pointer to back wall depth amount
  line(
    panHeight,
    -(panLineMargin + vLine - 5),
    panHeight + 10,
    -(panLineMargin + vLine - 5),
  );

  // Pointer to curb depth amount
  line(
    panHeight,
    panDepth + panLineMargin + vLine - 5,
    panHeight + 10,
    panDepth + panLineMargin + vLine - 5,
  );

  // Splash Wall Line
  line(
    0, 0,
    0, panDepth,
  );

  line(
    0, panDepth,
    panHeight, panDepth,
  );

  // Drain Line
  if (drainPosition === 'Back') {
    line(
      frontOfDrainMeetsFloor.x - grateThickness, frontOfDrainMeetsFloor.y,
      backOfDrainMeetsFloor.x - grateThickness, backOfDrainMeetsFloor.y,
    );
  } else {
    line(
      frontOfDrainMeetsFloor.x - grateThickness, curbMeetsFloor.y - (floorOutsideTrench / 2),
      backOfDrainMeetsFloor.x - grateThickness, floorMeetsBackSplashWall.y - splashWallWidth + (floorOutsideTrench / 2),
    );
  }

  textSize(14);

  // Curb Height
  this._createText(
    this.state.curbHeightInches,
    panHeight + vLine + 10,
    panDepth + panLineMargin + vLine,
  );

  // Depth line
  this._createMeasureLine(
    -(panLineMargin + vLine - 5),
    splashWallWidth,
    -(panLineMargin + vLine - 5),
    panDepth - curbWidth,
    this.state.panDepthInches - this.state.curbWidthInches - panBaseSpec.splashWallWidthInches,
  );

  // Curb Width
  this._createMeasureLine(
    -(panLineMargin + vLine - 5),
    panDepth - curbWidth,
    -(panLineMargin + vLine - 5),
    panDepth,
    this.state.curbWidthInches,
  );

  // Curb Height
  this._createMeasureLine(
    panHeight - curbHeight,
    panDepth + panLineMargin + vLine - 5,
    panHeight,
    panDepth + panLineMargin + vLine - 5,
  );

  // Back Splash Wall Depth
  this._createMeasureLine(
    0,
    -(panLineMargin + vLine - 5),
    panHeight,
    -(panLineMargin + vLine - 5),
  );

  // Pan Height Text
  this._createText(
    panBaseSpec.height,
    panHeight + 30,
    -(panLineMargin + vLine - 10),
  );

  // Splash wall width
  this._createArrow(
    -(panLineMargin + vLine - 5),
    -5,
    'down',
    5,
  );

  // Drain Width
  this._createMeasureLine(
    panHeight + vLine + 5,
    drainY - (drainPlateWidth / 2) + 1,
    panHeight + vLine + 5,
    drainY + (drainPlateWidth / 2) - 1,
    drainOpening,
  );

  push();
  translate(10, 10);
  rotate(-HALF_PI);

  this._createText(
    this.state.splashWallWidthInches,
    40,
    -(panLineMargin + vLine),
  );

  textSize(12);
  text(
    toleranceRange,
    -(panDepth + 60),
    -14,
  );

  textSize(20);
  text(
    'SECTION B-B',
    -((panDepth / 2) + (this._getTextWidth('SECTION B-B') / 2)),
    100,
  );

  pop();
  push();

  const drainGraphic = this._createTrenchDrain({
    ...vars, vLine,
  });

  rotate(-HALF_PI);

  image(
    drainGraphic,
    -(drainY + (drainWidth / 2) + 10),
    -12 + panHeight - trenchFloorThickness + grateThickness,
    // -(drainY + (drainWidth / 2) + 10),
    // panHeight - trenchFloorThickness - grateThickness,
  );

  pop();
}

